import {MenuItem} from 'primeng/api';
import {Settings} from './settings.interface';

export const trackingToolsInitialValue: Settings.TrackingToolsOptions = {
  'openingTracking': false, 'clickTracking': false, 'google': false, 'link_branding': false, link_branding_match_sender: false
};

export const notificationToolsInitialValue: Settings.NotificationToolsOptions = {
  'webhook': false, 'bccs': false, 'smtp_bounce': true, 'post_smtp_bounce': true, 'periodicReport': false, 'alerts': false
};

export const integrationToolsInitialValue: Settings.IntegrationToolsOptions = {
  'dkim': false, 'smtp': false
};

export const emailToolsInitialValue: Settings.EmailToolsOptions = {
  'templates': false, 'footers': false, 'unsubscribeLinks': false
};

export const notificationWebhookDeliveryEvents: string[] = ['SUCCESS', 'NEW', 'SYSFAIL', 'DEFER', 'FAIL'];
export const notificationWebhookEngagementEvents: string[] = ['OPEN', 'CLICK', 'UNSUB', 'REPORT'];

export const notificationsSMTPValues: Settings.SMTPTBodyOption[] = [
  {parameter: 'settings_notifications_smtp_server', value: 'settings_notifications_smtp_host', extra: '', translateValue: true},
  {parameter: 'settings_notifications_smtp_server', value: 'settings_notifications_smtp_host_eu', extra: '', translateValue: true},
  {parameter: 'settings_notification_smtp_auth', value: 'settings_notifications_smtp_auth_enabled', extra: ''},
  {parameter: 'settings_notifications_smtp_username', value: 'settings_apikeys_apikey_consumer', extra: '', translateExtra: false},
  {parameter: 'settings_notifications_smtp_password', value: 'settings_apikeys_apikey_secret', extra: '', translateExtra: false},
  //{id: 'smtpuser', parameter: 'settings_notifications_smtp_username', value: '', extra: '', translateValue: false, translateExtra: false},
  //{parameter: 'settings_notifications_smtp_password', value: 'settings_notifications_smtp_passvalue', extra: '', translateExtra: false},
  //{parameter: '', value: 'non-SSL', extra: 'SSL', translateValue: false, translateExtra: false},
  {
    parameter: 'settings_notifications_smtp_ports',
    //value: '25, 587, 2525',
    value: '<span class="flex gap-2"><span class="grow">SSL<br />465, 25025</span><span class="grow">non-SSL<br />25, 587, 2525</span></span>',
    //extra: '465, 25025',
    extra: '',
    translateValue: false,
    translateExtra: false
  }
];

export const settingsMenuItems: MenuItem[] = [
  {
    label: 'settings_integrations',
    icon: 'pi pi-link',
    routerLink: 'integrations'
  },
  /*{
    label: 'settings_senders_domains',
    icon: 'pi pi-book',
    routerLink: 'senders'
  },*/
  {
    label: 'settings_tracking',
    icon: 'pi pi-map-marker',
    routerLink: 'tracking'
  },
  {
    label: 'settings_notifications',
    icon: 'pi pi-calendar',
    routerLink: 'notifications'
  },
  {
    label: 'settings_email_elements',
    icon: 'pi pi-th-large',
    routerLink: 'emails'
  }
];

export const settingsHourOptions: Settings.PeriodicReportOption<string>[] = [
  {key: '00:00 GMT +0', id: 0}, {key: '01:00 GMT +0', id: 1},
  {key: '02:00 GMT +0', id: 2}, {key: '03:00 GMT +0', id: 3}, {key: '04:00 GMT +0', id: 4},
  {key: '05:00 GMT +0', id: 5}, {key: '06:00 GMT +0', id: 6}, {key: '07:00 GMT +0', id: 7},
  {key: '08:00 GMT +0', id: 8}, {key: '09:00 GMT +0', id: 9}, {key: '10:00 GMT +0', id: 10}, {key: '11:00 GMT +0', id: 11},
  {key: '12:00 GMT +0', id: 12}, {key: '13:00 GMT +0', id: 13}, {key: '14:00 GMT +0', id: 14}, {key: '15:00 GMT +0', id: 15},
  {key: '16:00 GMT +0', id: 16}, {key: '17:00 GMT +0', id: 17}, {key: '18:00 GMT +0', id: 18}, {key: '19:00 GMT +0', id: 19},
  {key: '20:00 GMT +0', id: 20}, {key: '21:00 GMT +0', id: 21}, {key: '22:00 GMT +0', id: 22}, {key: '23:00 GMT +0', id: 23},
];

export const settingsMonthOptions: Settings.PeriodicReportOption<number>[] = Array.from({length: 30}, (_, i) => {
  const n = i + 1;
  return {key: n, id: n};
});

export const settingsDayOptions: Settings.PeriodicReportOption<string>[] = [
  {
    key: 'monday',
    id: 1
  },
  {
    key: 'tuesday',
    id: 2
  },
  {
    key: 'wednesday',
    id: 3
  },
  {
    key: 'thursday',
    id: 4
  },
  {
    key: 'friday',
    id: 5
  },
  {
    key: 'saturday',
    id: 6
  },
  {
    key: 'sunday',
    id: 7
  }
];

export const settingsActivationRules: Record<Settings.PeriodicReportFrequency, string[]> = {
  'daily': ['daily_report_time'],
  'weekly': ['weekly_report_time', 'weekly_report_day'],
  'monthly': ['monthly_report_time', 'monthly_report_day']
};

export const settingsTemplateHtmlContainsWord = [/<% body %>/, /&lt;% body %&gt;/];

export const settingsUbsubLanguages: Settings.SettingsUnsubLanguage[] = [
  {
    id: 'eng',
    key: 'English'
  },
  {
    id: 'fre',
    key: 'French'
  },
  {
    id: 'ita',
    key: 'Italian'
  },
  {
    id: 'deu',
    key: 'German'
  },
  {
    id: 'spa',
    key: 'Spanish'
  },
  {
    id: 'por',
    key: 'Portuguese'
  }
];

export const settingsCustomTrackingDomainsLimit = 10;

export const settingsCustomTrackingDomainsFilters: Settings.TrackingDomainFilters = {
  'verified': [
    {
      label: 'settings_link_branding_verified', value: true
    },
    {
      label: 'settings_link_branding_not_verified', value: false
    }
  ],
  'ssl': [
    {
      label: 'settings_link_branding_https', value: true
    },
    {
      label: 'settings_link_branding_http', value: false
    }
  ],
  'enabled': [
    {
      label: 'settings_link_branding_status_enabled_yes', value: true
    },
    {
      label: 'settings_link_branding_status_enabled_no', value: false
    }
  ],
  'default': [
    {
      label: 'settings_link_branding_exclusive', value: false
    },
    {
      label: 'settings_link_branding_not_exclusive', value: true
    }
  ]
};

export const settingsCustomTrackingDomainsDnsCNAME = 'smtptrack.com';
